<template>
  <div class="row">
    <!-- <div style="margin-left: -100px; margin-top: 250px; position: absolute">
      <div
        class="right-button"
        v-if="this.scroll == true"
        v-on:click="getScroll2()"
      >
        <p style="font-size: 50px">&lt;</p>
      </div>
    </div>

    <div style="right: -100px; margin-top: 250px; position: absolute">
      <div
        class="right-button"
        v-if="this.scroll == false"
        v-on:click="getScroll()"
      >
        <p style="font-size: 50px">&gt;</p>
      </div>
    </div> -->

    <div class="col-lg-12">
      <StatusModal
        :show.sync="modals.removeModal"
        :message="modal.remove"
        :title="modal.removeTitle"
      />
      <StatusModal
        :show.sync="modals.successModal"
        :message="modal.success"
        :title="modal.successTitle"
      />

      <modal :show.sync="modals.dropjob" class="modal-eprf" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header=""
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">CANCELLATION REMARKS</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="modals.dropjob = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg-12">
              <textarea
                type="textarea"
                placeholder="Reason for rejection..."
                v-model="cancellationremarks"
                :class="{ textarea: true }"
              ></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-4 text-right">
              <base-button type="primary" v-on:click="cancelremarks()"
                >Submit</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>

      <modal :show.sync="modals.viewImage" class="modal-eprf" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">INSPECTION PICTURES</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="modals.viewImage = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg-12">
              <img :src="imagess" width="350" />
            </div>
          </div>
        </b-card>
      </modal>
      <div class="row">
        <div class="col-lg">
          <div class="scrollable-col">
            <!-- <div class="col-lg-1">
          <base-button
            type="primary"
            v-if="this.scroll == false"
            v-on:click="getScroll()"
            >Download</base-button
          >
        </div> -->
            <div class="row">
              <div class="col-lg-4 d-flex">
                <card class="card-eprf">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    JOB DETAILS
                  </p>
                  <div
                    style="height: 520px; overflow: auto; overflow-x: hidden"
                  >
                    <p class="new-title">Job Reference No.</p>
                    <p class="subtitle">{{ jobno }}</p>

                    <p class="new-title" v-if="landvesselflag == 'LAND'">
                      Collection Date
                    </p>
                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Arrival ETA
                    </p>
                    <p class="subtitle">{{ arrivalETA }}</p>

                    <p class="new-title" >
                      Service Location
                    </p>
                    <p class="subtitle" >
                      {{ servicelocation }}
                    </p>

                    <p class="new-title" >
                      Service Location Collection
                    </p>
                    <p class="subtitle" >
                      {{ servicelocationcollection }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Departure (ETD)
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ departureETD }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Previous Port
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ previousPort }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Next Port
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ nextPort }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Last Port When Generated Waste Delivered
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ lastPortAndDate }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Last Date When Generated Waste Delivered
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ lastDate }}
                    </p>

                    <p class="new-title">Company Name</p>
                    <p class="subtitle">{{ companyName }}</p>

                    <p class="new-title">Company Address</p>
                    <p class="subtitle">{{ companyAddress }}</p>

                    <p class="new-title">Phone No. / Fax No.</p>
                    <p class="subtitle">{{ phoneNoFaxNo }}</p>

                    <p class="new-title">PIC Full Name</p>
                    <p class="subtitle">{{ picFullName }}</p>

                    <p class="new-title">PIC Phone No. / Fax No.</p>
                    <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

                    <p class="new-title">PIC Email</p>
                    <p class="subtitle">{{ picEmail }}</p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Ship Name
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ shipName }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      IMO No.
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ imoNo }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Ship Type
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ shipType }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Gross Tonnage
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ grossTonnage }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Deadweight Tonnage (kg)
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ deadweightTonnage }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Owner / Operator Name
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ owneroperatorname }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Call Sign
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ callSign }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Flag State
                    </p>
                    <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ flagState }}
                    </p>

                    <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                      Sustainable Certificates
                    </p>
                    <!-- <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                      {{ sustainableCertificates }}
                    </p> -->

                    <div v-if="landvesselflag == 'VESSEL' && shipdoc.length !== 0" v-for="(file, index) in shipdoc"
                :key="'allship_file' + index" class="row">
                <div class="col-lg-8">
                  {{ index + 1 }}.
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
              </div>
              <p v-if="landvesselflag == 'VESSEL' && shipdoc.length === 0" class="subtitle">
                None
              </p>

                  </div>
                </card>
              </div>
              <div v-if="generate == true" class="col-lg-8 d-flex">
                <card class="card-eprf">
                  <p
                    v-if="jobno.startsWith('V')"
                    style="color: #358CCB; font-size: 24px; font-weight: 300"
                  >
                    WASTE DELIVERY RECEIPT (WDR)
                  </p>
                  <p
                    v-if="jobno.startsWith('L')"
                    style="color: #358CCB; font-size: 24px; font-weight: 300"
                  >
                    WASTE DELIVERY ORDER (WDO)
                  </p>
                  <p
                    v-if="positionid != 4"
                    style="margin-top: 50px"
                    class="newtitle"
                  >
                    Terminated PTW <span style="color: #EC1B23;">*</span>
                  </p>
                  <p class="sub-titles" v-if="positionid != 4">
                    Please upload terminated PTW file
                  </p>
                  <div class="fileinput" v-if="positionid != 4">
                    <label
                      for="terminated-ptw-upload"
                      type="primary"
                      class="btn"
                      style="
                        font-size: 13px;
                        color: #ffffff;
                        text-transform: capitalize;
                      "
                    >
                      <span>Choose File</span>
                    </label>
                    <div
                      class="d-flex justify-content-center spinner"
                      v-if="uploadloadTPTW == true"
                    >
                      <circle-8></circle-8>
                    </div>

                    <input
                      accept="application/pdf"
                      id="terminated-ptw-upload"
                      ref="terminatedptwfile"
                      type="file"
                      name="..."
                      class="valid"
                      :multiple="true"
                      aria-invalid="false"
                      style="display: none"
                      v-on:change="onFileChangeTPTW"
                    />
                  </div>

                  <div v-if="allfileTPTWname.length > 0" class="row">
                    <div class="col-lg-8">
                      <a :href="allfileTPTWname[0].fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ allfileTPTWname[0].filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="positionid != 4">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removePTWFile()"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>

                  <p
                    style="margin-top: 50px"
                    class="newtitle"
                    v-if="positionid != 4 && jobno.startsWith('V')"
                  >
                    Waste Delivery Receipt <span style="color: #EC1B23;">*</span>
                  </p>

                  <p
                    style="margin-top: 50px"
                    class="newtitle"
                    v-if="positionid != 4 && jobno.startsWith('L')"
                  >
                    Waste Delivery Order <span style="color: #EC1B23;">*</span>
                  </p>

                  <p
                    class="sub-titles"
                    v-if="positionid != 4 && jobno.startsWith('V')"
                  >
                    Please upload signed WDR
                  </p>
                  <p
                    class="sub-titles"
                    v-if="positionid != 4 && jobno.startsWith('L')"
                  >
                    Please upload signed WDO
                  </p>
                  <div class="fileinput" v-if="positionid != 4">
                    <label
                      for="receipt-upload"
                      type="primary"
                      class="btn"
                      style="
                        font-size: 13px;
                        color: #ffffff;
                        text-transform: capitalize;
                      "
                    >
                      Choose File
                    </label>
                    <div
                      class="d-flex justify-content-center spinner"
                      v-if="uploadreceipt == true"
                    >
                      <circle-8></circle-8>
                    </div>

                    <input
                      accept="application/pdf"
                      id="receipt-upload"
                      ref="receiptupload"
                      type="file"
                      name="..."
                      class="valid"
                      :multiple="true"
                      aria-invalid="false"
                      style="display: none"
                      v-on:change="onReceiptChange"
                    />
                  </div>
                  <div
                    style="
                      height: 50px;
                      padding: 0px 20px 0px 0px;
                      margin: 0px 30px 0px 0px;
                    "
                    class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                  >
                    <div
                      v-for="(filee, index) in allreceiptPTW"
                      :key="index"
                      class="row"
                    >
                      <div class="col-lg-8">
                        Rev {{ filee.rev }}
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                      <div class="col-lg-4" v-if="positionid != 4">
                        <base-button
                          class="btn-sm btn-cancel"
                          style="font-size: 12px"
                          @click="removeReceipt(filee.fileid)"
                        >
                          Remove
                        </base-button>
                      </div>
                    </div>
                  </div>

                  <p
                    v-if="jobno.startsWith('V')"
                    style="margin-top: 20px"
                    class="newtitle"
                  >
                    View Your Generated WDR
                  </p>
                  <p
                    v-if="jobno.startsWith('L')"
                    style="margin-top: 20px"
                    class="newtitle"
                  >
                    View Your Generated WDO
                  </p>
                  <!-- pdf sini sw wdo -->
                  <base-button
                    v-if="jobno.startsWith('L')"
                    type="primary"
                    @click="createWDO"
                    >View</base-button
                  >
                  <base-button
                    v-if="jobno.startsWith('V')"
                    type="primary"
                    @click="createPDFnew"
                    >View</base-button
                  >
                  <!-- <base-button type="primary" @click="createPDFnew">View</base-button> -->

                  <!-- <base-button type="primary" v-on:click="getLogin()"
                  >Choose File</base-button
                > -->
                </card>
              </div>
              <div class="col-lg-8 d-flex" v-if="generate == false">
                <card class="card-eprf">
                  <div class="row">
                    <div class="col-lg">
                      <p
                        style="
                          color: #358CCB;
                          font-size: 24px;
                          font-weight: 300;
                        "
                      >
                        WASTE DETAILS
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-lg"
                      style="height: 520px; overflow: auto; overflow-x: hidden"
                    >
                      <!--   :cell-class-name="evenclass" -->

                      <el-table
                        :data="wastedetails"
                        :header-cell-style="{
                          background: '#358DCC',
                          border: 'transparent',
                          'font-size': '14px',
                          'font-weight': '400',
                          color: '#FFFFFF',
                        }"
                        :cell-style="{ fontColor: '#707070' }"
                        :row-style="tableRowClassName"
                        style="color: #707070"
                      >
                        <el-table-column label="NO." width="50" align="center">
                          <div slot-scope="scope">
                            <p style="color: #707070">{{ scope.$index + 1 }}</p>
                          </div>
                        </el-table-column>

                        <el-table-column
                          label="WASTE TYPE"
                          prop="wastetype"
                          :min-width="200"
                          align="center"
                        >
                          <div slot-scope="{ row }">
                            <div align="left">
                              <div class="row">
                                <div class="col-lg">
                                  <p style="color: #A5A5A5">
                                    Waste Type: {{ row.wastetype }}
                                  </p>

                                  <p style="color: #A5A5A5" class="swcode-text">
                                    SW Code: {{ row.wastesubtype }}
                                  </p>
                                  <!-- <p style="color: #A5A5A5">
                            Packaging Type: {{ row.packagingtype }}
                          </p> -->
                                  <br />
                                  <!-- <p style="color: #A5A5A5">Waste Origin</p>
                          <p style="color: #A5A5A5; font-weight: bold">
                            {{ row.wasteorigin }}
                          </p> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-table-column>
                        <el-table-column
                          label="WASTE QTY."
                          prop="wasteqty"
                          :min-width="80"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          v-if="landvesselflag == 'LAND' || landvesselflag == 'VESSEL'"
                          label="ACTUAL QTY."
                          prop="actual"
                          :min-width="80"
                          align="center"
                        ></el-table-column>
                        <!-- <el-table-column
                          v-if="landvesselflag == 'LAND'"
                          label="CALCULATED QTY."
                          prop="calculated"
                          :min-width="60"
                          align="center"
                        ></el-table-column> -->
                        <el-table-column
                          v-if="landvesselflag == 'VESSEL'"
                          align="center"
                          label="MAX DEDICATED STORAGE CAPACITY"
                          prop="maxdedicatedstoragecapacity"
                          :min-width="150"
                        ></el-table-column>
                        <el-table-column
                          v-if="landvesselflag == 'VESSEL'"
                          align="center"
                          label="WASTE AMOUNT RETAINED ON-BOARD"
                          prop="wasteamountretainedonboard"
                          :min-width="155"
                        ></el-table-column>
                        <el-table-column
                          :min-width="200"
                          align="center"
                          label="REMARKS"
                          prop="remarks"
                        ></el-table-column>
                      </el-table>
                    </div>
                  </div>
                </card>
                <!-- <card
            style="
            box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              WASTE DETAILS
            </p>

            <div
              style="margin-left: -30px"
              class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
            >
              <p class="new-title">Waste Type</p>
              <p class="subtitle">Annex I - Oily bilge water</p>

              <p class="new-title">Name of Waste</p>
              <p class="subtitle">Waste Catalysts</p>

              <p class="new-title">Waste Component</p>
              <p class="subtitle">1. Iron</p>
              <p class="subtitle">2. Water</p>

              <p class="new-title">Waste Origin / Source</p>
              <p class="subtitle">Steel Factory</p>

              <p class="new-title">Waste Type</p>
              <p class="subtitle">Sludge</p>

              <p class="new-title">Packaging Type</p>
              <p class="subtitle">Pallet Container</p>

              <p class="new-title">Packing Quantity</p>
              <p class="subtitle">100kg</p>

              <p class="new-title">Packing No</p>
              <p class="subtitle">10</p>

              <p class="new-title">Handling Method</p>
              <p class="subtitle">None</p>

              <p class="new-title">Hazard Information</p>
              <p class="subtitle">None</p>

              <p class="new-title">Approved Quantity by Customer</p>
              <p class="subtitle">300 MT</p>
            </div>
          </card> -->
              </div>
            </div>

            <div v-if="jobno.startsWith('V')">
              <div class="row">
                <div class="col-lg-4 d-flex" v-if="generate == false">
                  <card
                    style="
                      box-shadow: none;
                      color: #A5A5A5;
                      padding: 0px 0px 30px 30px;
                      height: 630px;
                      background-color: white;
                    "
                  >
                    <div class="row">
                      <div class="col-lg">
                        <p
                          style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          "
                        >
                          UPLOAD LAB REPORT
                        </p>
                      </div>
                    </div>
                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <input
                          type="checkbox"
                          class="rounded-checkbox"
                          id="checkbox"
                          v-model="checkedItems"
                          :value="required[0].value"
                        />&nbsp;&nbsp; {{ required[0].label }}
                      </div>
                    </div>

                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <div style="padding-top: 10px; margin-right: 30px">
                          <div
                            class="w-100 p-4 d-flex align-items-center justify-content-center"
                            style="
                              border: 2px dashed lightgray;
                              height: 280px;
                              width: 350px;
                            "
                          >
                            <div class="col-lg-12 text-center">
                              <i
                                style="
                                  color: lightgray;
                                  font-size: 90px;
                                  font-weight: 500;
                                  margin-bottom: 10px;
                                "
                                class="tim-icons icon-upload"
                              ></i>

                              <p style="font-weight: 600; color: #707070">
                                Drop files to upload
                              </p>
                              <div class="row">
                                <div class="col-lg"></div>

                                <p
                                  style="font-weight: 600; color: #707070"
                                >
                                  or
                                </p>
                                &nbsp;
                                <div class="fileinput">
                                  <label for="lab-upload">
                                    <p
                                      v-if="checkedItems == false"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: #358CCB;
                                        cursor: pointer;
                                      "
                                    >
                                      browse
                                    </p>
                                    <p
                                      v-if="checkedItems == true"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: grey;
                                      "
                                    >
                                      browse
                                    </p>
                                  </label>
                                  <input
                                    accept="application/pdf"
                                    id="lab-upload"
                                    type="file"
                                    ref="labreport"
                                    name="labreport"
                                    class="valid"
                                    :multiple="true"
                                    aria-invalid="false"
                                    style="display: none"
                                    v-on:change="onLabChange"
                                    :disabled="disablecheckedItems"
                                  />
                                </div>

                                <div class="col-lg"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            height: 100px;
                            padding: 20px 20px 0px 20px;
                            margin: 30px 30px 0px 0px;
                          "
                          class="d-flex justify-content-center spinner"
                          v-if="uploadlabreport == true"
                        >
                          <circle-8></circle-8>
                        </div>
                      </div>
                    </div>
                    <br />
                    <!-- padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px; -->
                    <!-- scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
                    <div
                      style="height: 200px; overflow-y: auto"
                      class=""
                      v-if="uploadlabreport != true"
                    >
                      <div
                        v-for="(file, index) in allfilename"
                        :key="index"
                        class="row"
                        style="width: 100%"
                      >
                        <div class="col-lg-8">
                          <a :href="file.fileurl">
                            <base-button class="btn-link btn-primary">
                              {{ file.filename }}
                            </base-button>
                          </a>
                        </div>
                        <div
                          class="col-lg-4 text-center"
                          v-if="positionid != 4"
                        >
                          <base-button
                            class="btn-sm btn-cancel"
                            style="font-size: 12px"
                            @click="removeFile(file.fileid)"
                          >
                            Remove
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <!-- </div> -->
                <!-- <div v-else class="row"> -->
                <div class="col-lg-4 d-flex" v-if="generate == false">
                  <card
                    class="card-eprf"
                    style="
                      box-shadow: none;
                      color: #A5A5A5;
                      padding: 0px 0px 30px 30px;
                      height: 630px;
                      background-color: white;
                    "
                  >
                    <div class="row">
                      <div class="col-lg">
                        <p
                          style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          "
                        >
                          UPLOAD INSPECTION PICTURES
                        </p>
                      </div>
                    </div>
                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <input
                          type="checkbox"
                          class="rounded-checkbox"
                          id="checkbox"
                          v-model="checkedItems1"
                        />&nbsp;&nbsp;{{ required[1].label }}
                      </div>
                    </div>

                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <div style="margin-top: 10px; margin-right: 30px">
                          <div
                            class="w-100 p-4 d-flex align-items-center justify-content-center"
                            style="
                              border: 2px dashed lightgray;
                              height: 280px;
                              width: 350px;
                            "
                          >
                            <div class="col-lg-12 text-center">
                              <i
                                style="
                                  color: lightgray;
                                  font-size: 90px;
                                  font-weight: 500;
                                  margin-bottom: 10px;
                                "
                                class="tim-icons icon-upload"
                              ></i>

                              <p style="font-weight: 600; color: #707070">
                                Drop files to upload
                              </p>
                              <div class="row">
                                <div class="col-lg"></div>

                                <p
                                  style="font-weight: 600; color: #707070"
                                >
                                  or
                                </p>
                                &nbsp;
                                <div class="fileinput">
                                  <label for="image-upload">
                                    <p
                                      v-if="checkedItems1 == false"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: #358CCB;
                                        cursor: pointer;
                                      "
                                    >
                                      browse
                                    </p>
                                    <p
                                      v-if="checkedItems1 == true"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: grey;
                                      "
                                    >
                                      browse
                                    </p>
                                  </label>
                                  <input
                                    accept="image/*"
                                    id="image-upload"
                                    type="file"
                                    ref="imageupload"
                                    name="..."
                                    class="valid"
                                    :multiple="true"
                                    aria-invalid="false"
                                    style="display: none"
                                    v-on:change="onImagesChange"
                                    :disabled="disablecheckedItems1"
                                  />
                                </div>

                                <div class="col-lg"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- -->
                    <div
                      style="
                        height: 100px;
                        padding: 20px 20px 0px 20px;
                        margin: 30px 30px 0px 0px;
                      "
                      class="d-flex justify-content-center spinner"
                      v-if="uploadimage == true"
                    >
                      <circle-8></circle-8>
                    </div>
                    <br />
                    <!-- padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px; 
                    scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
                    <div
                      style="height: 200px; overflow-y: auto"
                      class=""
                      v-if="uploadimage != true"
                    >
                      <div
                        v-for="(file, index) in allimagename"
                        :key="index"
                        class="row"
                        style="width: 100%"
                      >
                        <div class="col-lg-8">
                          <p
                            class="btn-view-image"
                            style="padding-left: 15px; color: #A5A5A5"
                            id="file-name"
                            @click="viewImage(file)"
                          >
                            {{ file.filename }}
                          </p>
                        </div>
                        <div
                          class="col-lg-4 text-center"
                          v-if="positionid != 4"
                        >
                          <base-button
                            class="btn-sm btn-cancel"
                            style="font-size: 12px"
                            @click="removeImage(file.fileid)"
                          >
                            Remove
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg-4 d-flex" v-if="generate == false">
                  <card
                    style="
                      box-shadow: none;
                      color: #A5A5A5;
                      padding: 0px 0px 30px 30px;
                      height: 630px;
                      background-color: white;
                    "
                  >
                    <div class="row">
                      <div class="col-lg">
                        <p
                          style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          "
                        >
                          UPLOAD TIMESHEET
                        </p>
                      </div>
                    </div>

                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <input
                          type="checkbox"
                          class="rounded-checkbox"
                          id="checkbox"
                          v-model="checkedItems2"
                        />&nbsp;&nbsp; Not required
                      </div>
                    </div>
                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <div style="margin-top: 10px; margin-right: 30px">
                          <div
                            class="w-100 p-4 d-flex align-items-center justify-content-center"
                            style="
                              border: 2px dashed lightgray;
                              height: 280px;
                              width: 350px;
                            "
                          >
                            <div class="col-lg-12 text-center">
                              <i
                                style="
                                  color: lightgray;
                                  font-size: 90px;
                                  font-weight: 500;
                                  margin-bottom: 10px;
                                "
                                class="tim-icons icon-upload"
                              ></i>

                              <p style="font-weight: 600; color: #707070">
                                Drop files to upload
                              </p>
                              <div class="row">
                                <div class="col-lg"></div>

                                <p
                                  style="font-weight: 600; color: #707070"
                                >
                                  or
                                </p>
                                &nbsp;
                                <div class="fileinput">
                                  <label for="timesheet-upload">
                                    <p
                                      v-if="checkedItems2 == false"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: #358CCB;
                                        cursor: pointer;
                                      "
                                    >
                                      browse
                                    </p>
                                    <p
                                      v-if="checkedItems2 == true"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: grey;
                                      "
                                    >
                                      browse
                                    </p>
                                  </label>
                                  <input
                                    id="timesheet-upload"
                                    type="file"
                                    ref="timesheetupload"
                                    name="..."
                                    class="valid"
                                    :multiple="true"
                                    aria-invalid="false"
                                    style="display: none"
                                    v-on:change="onTimesheetChange"
                                    :disabled="disablecheckedItems2"
                                  />
                                </div>

                                <div class="col-lg"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            height: 100px;
                            padding: 20px 20px 0px 20px;
                            margin: 30px 30px 0px 0px;
                          "
                          class="d-flex justify-content-center spinner"
                          v-if="uploadtimesheet == true"
                        >
                          <circle-8></circle-8>
                        </div>
                      </div>
                    </div>
                    <br />
                    <!-- padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px;
                      scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
                    <div
                      style="height: 200px; overflow-y: auto"
                      class=""
                      v-if="uploadtimesheet != true"
                    >
                      <div
                        v-for="(file, index) in timesheets"
                        :key="index"
                        class="row"
                        style="width: 100%"
                      >
                        <div class="col-lg-8">
                          <a :href="file.fileurl">
                            <base-button class="btn-link btn-primary">
                              {{ file.filename }}
                            </base-button>
                          </a>
                        </div>
                        <div
                          class="col-lg-4 text-center"
                          v-if="positionid != 4"
                        >
                          <base-button
                            class="btn-sm btn-cancel"
                            style="font-size: 12px"
                            @click="removeTimesheet(file.fileid)"
                          >
                            Remove
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>

            <div v-if="jobno.startsWith('L')">
              <div class="row">
                <div class="col-lg-6 d-flex" v-if="generate == false">
                  <card
                    style="
                      box-shadow: none;
                      color: #A5A5A5;
                      padding: 0px 0px 30px 30px;
                      height: 630px;
                      background-color: white;
                    "
                  >
                    <div class="row">
                      <div class="col-lg">
                        <p
                          style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          "
                        >
                          UPLOAD LAB REPORT
                        </p>
                      </div>
                    </div>
                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <input
                          type="checkbox"
                          class="rounded-checkbox"
                          id="checkbox"
                          v-model="checkedItems"
                          :value="required[0].value"
                        />&nbsp;&nbsp; {{ required[0].label }}
                      </div>
                    </div>

                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <div style="padding-top: 10px; margin-right: 30px">
                          <div
                            class="w-100 p-4 d-flex align-items-center justify-content-center"
                            style="
                              border: 2px dashed lightgray;
                              height: 280px;
                              width: 350px;
                            "
                          >
                            <div class="col-lg-12 text-center">
                              <i
                                style="
                                  color: lightgray;
                                  font-size: 90px;
                                  font-weight: 500;
                                  margin-bottom: 10px;
                                "
                                class="tim-icons icon-upload"
                              ></i>

                              <p style="font-weight: 600; color: #707070">
                                Drop files to upload
                              </p>
                              <div class="row">
                                <div class="col-lg"></div>

                                <p
                                  style="font-weight: 600; color: #707070"
                                >
                                  or
                                </p>
                                &nbsp;
                                <div class="fileinput">
                                  <label for="lab-upload">
                                    <p
                                      v-if="checkedItems == false"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: #358CCB;
                                        cursor: pointer;
                                      "
                                    >
                                      browse
                                    </p>
                                    <p
                                      v-if="checkedItems == true"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: grey;
                                      "
                                    >
                                      browse
                                    </p>
                                  </label>
                                  <input
                                    accept="application/pdf"
                                    id="lab-upload"
                                    type="file"
                                    ref="labreport"
                                    name="labreport"
                                    class="valid"
                                    :multiple="true"
                                    aria-invalid="false"
                                    style="display: none"
                                    v-on:change="onLabChange"
                                    :disabled="disablecheckedItems"
                                  />
                                </div>

                                <div class="col-lg"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            height: 100px;
                            padding: 20px 20px 0px 20px;
                            margin: 30px 30px 0px 0px;
                          "
                          class="d-flex justify-content-center spinner"
                          v-if="uploadlabreport == true"
                        >
                          <circle-8></circle-8>
                        </div>
                      </div>
                    </div>
                    <br />
                    <!-- padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px; -->
                    <!-- scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
                    <div
                      style="height: 200px; overflow-y: auto"
                      class=""
                      v-if="uploadlabreport != true"
                    >
                      <div
                        v-for="(file, index) in allfilename"
                        :key="index"
                        class="row"
                        style="width: 100%"
                      >
                        <div class="col-lg-8">
                          <a :href="file.fileurl">
                            <base-button class="btn-link btn-primary">
                              {{ file.filename }}
                            </base-button>
                          </a>
                        </div>
                        <div
                          class="col-lg-4 text-center"
                          v-if="positionid != 4"
                        >
                          <base-button
                            class="btn-sm btn-cancel"
                            style="font-size: 12px"
                            @click="removeFile(file.fileid)"
                          >
                            Remove
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <!-- </div> -->
                <!-- <div v-else class="row"> -->
                <div class="col-lg-6 d-flex" v-if="generate == false">
                  <card
                    class="card-eprf"
                    style="
                      box-shadow: none;
                      color: #A5A5A5;
                      padding: 0px 0px 30px 30px;
                      height: 630px;
                      background-color: white;
                    "
                  >
                    <div class="row">
                      <div class="col-lg">
                        <p
                          style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          "
                        >
                          UPLOAD INSPECTION PICTURES
                        </p>
                      </div>
                    </div>
                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <input
                          type="checkbox"
                          class="rounded-checkbox"
                          id="checkbox"
                          v-model="checkedItems1"
                        />&nbsp;&nbsp;{{ required[1].label }}
                      </div>
                    </div>

                    <div class="row" v-if="positionid != 4">
                      <div class="col-lg">
                        <div style="margin-top: 10px; margin-right: 30px">
                          <div
                            class="w-100 p-4 d-flex align-items-center justify-content-center"
                            style="
                              border: 2px dashed lightgray;
                              height: 280px;
                              width: 350px;
                            "
                          >
                            <div class="col-lg-12 text-center">
                              <i
                                style="
                                  color: lightgray;
                                  font-size: 90px;
                                  font-weight: 500;
                                  margin-bottom: 10px;
                                "
                                class="tim-icons icon-upload"
                              ></i>

                              <p style="font-weight: 600; color: #707070">
                                Drop files to upload
                              </p>
                              <div class="row">
                                <div class="col-lg"></div>

                                <p
                                  style="font-weight: 600; color: #707070"
                                >
                                  or
                                </p>
                                &nbsp;
                                <div class="fileinput">
                                  <label for="image-upload">
                                    <p
                                      v-if="checkedItems1 == false"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: #358CCB;
                                        cursor: pointer;
                                      "
                                    >
                                      browse
                                    </p>
                                    <p
                                      v-if="checkedItems1 == true"
                                      style="
                                        font-weight: 600;
                                        font-size: 14px;
                                        color: grey;
                                      "
                                    >
                                      browse
                                    </p>
                                  </label>
                                  <input
                                    accept="image/*"
                                    id="image-upload"
                                    type="file"
                                    ref="imageupload"
                                    name="..."
                                    class="valid"
                                    :multiple="true"
                                    aria-invalid="false"
                                    style="display: none"
                                    v-on:change="onImagesChange"
                                    :disabled="disablecheckedItems1"
                                  />
                                </div>

                                <div class="col-lg"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- -->
                    <div
                      style="
                        height: 100px;
                        padding: 20px 20px 0px 20px;
                        margin: 30px 30px 0px 0px;
                      "
                      class="d-flex justify-content-center spinner"
                      v-if="uploadimage == true"
                    >
                      <circle-8></circle-8>
                    </div>
                    <br />
                    <!-- padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px; 
                    scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
                    <div
                      style="height: 200px; overflow-y: auto"
                      class=""
                      v-if="uploadimage != true"
                    >
                      <div
                        v-for="(file, index) in allimagename"
                        :key="index"
                        class="row"
                        style="width: 100%"
                      >
                        <div class="col-lg-8">
                          <p
                            class="btn-view-image"
                            style="padding-left: 15px; color: #A5A5A5"
                            id="file-name"
                            @click="viewImage(file)"
                          >
                            {{ file.filename }}
                          </p>
                        </div>
                        <div
                          class="col-lg-4 text-center"
                          v-if="positionid != 4"
                        >
                          <base-button
                            class="btn-sm btn-cancel"
                            style="font-size: 12px"
                            @click="removeImage(file.fileid)"
                          >
                            Remove
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            wide
            type="cancel"
            @click="opendropjob()"
            class="btn-dispute"
          >
            CANCEL JOB
          </base-button>
          <base-button
            v-if="generate == false"
            wide
            type="danger"
            @click.native="prevTab"
            class="btn-previous"
          >
            BACK
          </base-button>
          <base-button
            v-if="generate == true"
            wide
            type="danger"
            @click.native="generate = false"
            class="btn-previous"
          >
            BACK
          </base-button>
          <base-button
            v-if="generate == false"
            type="primary"
            wide
            @click="generateWDR()"
            class="btn-next"
          >
            NEXT
          </base-button>
          <!-- next ke invoice -->
          <base-button
            v-if="generate == true"
            type="primary"
            wide
            @click="generateInvoice()"
            @click.native="nextTab"
            class="btn-next"
            :disabled="disablebtn"
          >
            NEXT
          </base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            class="btn-link"
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </base-button>
          <!-- <p
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p> -->
        </div>
      </div>
      <div id="quopdf" ref="quopdf" :style="styledef">
        <div class="row">
          <div class="col-lg-8">
            <div class="row quo">
              <div class="col-lg-12 text-right">
                <p class="quo">WDR NO: {{ wdr.wdrno }}</p>
              </div>
            </div>

            <div class="row quo">
              <div class="col-lg-6 text-left">
                <img src="@/assets/img/northport.png" width="150" />
              </div>
              <div class="col-lg-6 text-right">
                <img src="@/assets/img/Afes-logo.png" width="150" />
              </div>
            </div>
            <div class="row quo" style="border-bottom: 1px solid #000000"></div>
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <h3 class="quo">WASTE DELIVERY REPORT</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-left">
                <p class="quo">
                  <i
                    >This form should be retained on board the vessel along with
                    the appropriate Oil RB, Cargo RB or Garbage RB</i
                  >
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-left">
                <h3 class="quo">1. RECEPTION FACILITY AND PORT PARTICULARS</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <table>
                  <tr>
                    <td style="background-color: #dadada">1.1</td>
                    <td>Location/Terminal name: {{ wdr.locationname }}</td>
                  </tr>
                  <tr>
                    <td style="background-color: #dadada">1.2</td>
                    <td>
                      Reception facility provider(s):
                      {{ wdr.receptionfacility }}
                    </td>
                  </tr>
                  <tr>
                    <td style="background-color: #dadada">1.3</td>
                    <td>
                      Treatment facility provider(s) - if different from above:
                      {{ wdr.treatmentfacility }}
                    </td>
                  </tr>
                  <tr>
                    <td style="background-color: #dadada">1.4</td>
                    <td>
                      Waste Discharge Date: {{ wdr.date }} and Time from:
                      {{ wdr.starttime }} to {{ wdr.endtime }}

                      <!-- Waste Discharge: {{  wdr.date  }} from {{ wdr.starttime }} to {{ wdr.endtime }}-->
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg text-left">
                <h3 class="quo">2. SHIP PARTICULARS</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <table>
                  <tr>
                    <td style="background-color: #dadada">2.1</td>
                    <td>Name of ship: {{ wdr.shipname }}</td>
                    <td style="background-color: #dadada">2.5</td>
                    <td>Owner or operator: {{ wdr.owner }}</td>
                  </tr>
                  <tr>
                    <td style="background-color: #dadada">2.2</td>
                    <td>IMO number: {{ wdr.imonumber }}</td>
                    <td style="background-color: #dadada">2.6</td>
                    <td>
                      Distinctive number or letters: {{ wdr.distinctive }}
                    </td>
                  </tr>
                  <tr>
                    <td style="background-color: #dadada">2.3</td>
                    <td>Gross tonnage: {{ wdr.grosstonnage }}</td>
                    <td style="background-color: #dadada">2.7</td>
                    <td>Flag state: {{ wdr.flagstate }}</td>
                  </tr>
                  <tr>
                    <td style="background-color: #dadada">2.4</td>
                    <td colspan="3">
                      Type of ship: Oil tanker / Chemical tanker / Bulk carrier
                      / Container <br />
                      Other cargo ship / Passenger ship / Ro-ro / Other(specify)
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg text-left">
                <h3 class="quo">3. RECEPTION FACILITY AND PORT PARTICULARS</h3>
              </div>
            </div>
            <div class="row">
              <div
                class="col-lg-6"
                v-for="(item, index) in wdr.wastedetails"
                :key="index"
              >
                <table>
                  <tr style="background-color: #dadada">
                    <td>{{ item.wastetype }}</td>
                    <td>Quantity (m3)</td>
                  </tr>
                  <tr v-for="(perkara, i) in item.wastesub" :key="i">
                    <td>{{ perkara.name }}</td>
                    <td>{{ perkara.amount }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-left">
                <p class="quo">
                  On behalf of the port facility I confirm that the above wastes
                  were delivered.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 text-left">
                <p class="quo">Signature:</p>
              </div>
              <div class="col-lg-6 text-left">
                <p class="quo">Full Name and Company Stamp:</p>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg-6 text-left">
                <p class="quo">Client signature:</p>
              </div>
              <div class="col-lg-6 text-left">
                <p class="quo">Full Name and Company Stamp:</p>
              </div>
            </div>
            <br />
            <div class="row">
              <div
                class="col-lg text-left"
                style="border-bottom: 1px solid #000000"
              >
                <p class="quo">
                  {{ jobno }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  // props: ["parentData"],
  components: {
    ImageUpload,
    StatusModal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    Circle8,
    html2canvas,
    Modal,
    BCard,
  },
  props: ["test1"],
  data() {
    return {
      allfileTPTWname: [],
      selectedFileNamePTW: "",
      uploadloadTPTW: false,
      uploadterminatedPTW: false,
      docsPTW: "",
      allfilenamePTW: [],

      oiltanker: "",
      chemicaltanker: "",
      bulkcarrier: "",
      container: "",
      othercargoship: "",
      passenger: "",
      roro: "",
      other: "",

      aa: "",
      aaa: "",
      aremark: "",
      bb: "",
      bbb: "",
      bremark: "",
      cc: "",
      ccc: "",
      cremark: "",
      dd: "",
      ddd: "",
      dremark: "",
      ee: "",
      eee: "",
      eremark: "",
      ff: "",
      fff: "",
      fremark: "",
      aastorage: "",
      bbstorage: "",
      ccstorage: "",
      ddstorage: "",
      eestorage: "",
      ffstorage: "",
      aaretain: "",
      bbretain: "",
      ccretain: "",
      ddretain: "",
      eeretain: "",
      ffretain: "",
      ffspecify: "",

      sewage: "",
      sewageremark: "",
      sewagestorage: "",
      sewageretain: "",

      a: "",
      b: "",
      c: "",
      d: "",
      e: "",
      f: "",
      fspecify: "",
      g: "",
      gremark: "",
      gspecify: "",
      h: "",
      hremark: "",
      i: "",
      iremark: "",

      ozone: "",
      ozonestorage: "",
      ozoneretain: "",
      ozoneremark: "",

      exhaust: "",
      exhauststorage: "",
      exhaustretain: "",
      exhaustremark: "",

      xpdf: "",
      xspdf: "",
      xspecify: "",
      ypdf: "",
      yypdf: "",
      yspecify: "",
      otherspecify: "",
      zpdf: "",
      zzpdf: "",
      zspecify: "",
      ospdf: "",
      osspdf: "",
      ospecify: "",

      modal: modal,
      timesheets: [],
      uploadreceipt: false,
      uploadlabreport: false,
      cancellationremarks: "",
      disablebtn: true,
      imagess: "",
      styledef: "display: none",
      allreceiptPTW: [],
      allterminatedPTW: [],

      jobno: "",
      arrivalETA: "18 Nov 2022",
      collectiondate: "",
      servicelocation: "",
      servicelocationcollection: "",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      lastDate: "",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      shipdoc: [],

      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
      ],

      generate: false,
      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      checkedItems: "",
      disablecheckedItems: false,
      checkedItems1: "",
      disablecheckedItems1: false,
      checkedItems2: "",
      disablecheckedItems2: false,
      required: [
        { value: 0, label: "Not required" },
        {
          value: 1,
          label: "Not required",
        },
      ],

      selectedFileName: "",
      allfilename: [],
      documentID: [],

      uploadload: false,

      selectedImageName: "",
      allimagename: [],
      imageID: [],
      uploadimage: false,
      uploadtimesheet: false,
      landvesselflag: "",
      wdr: {
        wdrno: "ABC12312312312",
        locationname: "location a",
        receptionfacility: "NORTHPORT (MALAYSIA)",
        treatmentfacility: "nono",
        date: "2024-08-01",
        starttime: "08:00",
        endtime: "09:00",
        shipname: "kapal laut",
        owner: "ayam",
        imonumber: "33333",
        distinctive: "",
        grosstonnage: "",
        flagstate: "",
        wastedetails: [
          {
            wastetype: "Type A",
            wastesub: [
              {
                name: "Waste Sub A",
                amount: 3,
              },
              {
                name: "Waste Sub b",
                amount: 78,
              },
            ],
          },
          {
            wastetype: "Type B",
            wastesub: [
              {
                name: "Waste Sub A",
                amount: 3,
              },
              {
                name: "Waste Sub b",
                amount: 3,
              },
            ],
          },
          {
            wastetype: "Type C",
            wastesub: [
              {
                name: "Waste Sub A",
                amount: 3,
              },
              {
                name: "Waste Sub b",
                amount: 3,
              },
            ],
          },
        ],
      },
      quo: {
        companyname: "XXX (M) Berhad",
        add1: "ksdjfsd",
        add2: "kfgnkdf",
        add3: "ksksn",
        add4: "sdklfjskl",
        refno: "sd",
        date: "sd",
        page: "1 of 2 pages",
      },
      message: "",
      modals: {
        successModal: false,
        removeModal: false,
        viewImage: false,
        dropjob: false,
      },
      successModalFlag: "",
      positionid: "",

      wastecomponent: [],
    };
  },
  created() {
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();

    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
  },
  mounted() {
    // this.getDetail();
  },
  watch: {
    checkedItems() {
      if (this.checkedItems == true) {
        this.disablecheckedItems = true;
      } else {
        this.disablecheckedItems = false;
      }
    },
    checkedItems1() {
      if (this.checkedItems1 == true) {
        this.disablecheckedItems1 = true;
      } else {
        this.disablecheckedItems1 = false;
      }
    },
    checkedItems2() {
      if (this.checkedItems2 == true) {
        this.disablecheckedItems2 = true;
      } else {
        this.disablecheckedItems2 = false;
      }
    },
    allreceiptPTW: {
      handler: function (val, oldVal) {
        if (
          this.allreceiptPTW.length != 0 &&
          this.allfileTPTWname.length != 0
        ) {
          this.disablebtn = false;
        } else {
          this.disablebtn = true;
        }
      },
      deep: true,
    },

    allfileTPTWname: {
      handler: function (val, oldVal) {
        if (
          this.allfileTPTWname.length != 0 &&
          this.allreceiptPTW.length != 0
        ) {
          this.disablebtn = false;
        } else {
          this.disablebtn = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    onFileChangeTPTW(event) {
      this.uploadloadTPTW = true;

      if (this.allfileTPTWname.length == 0) {
        this.docsPTW = this.$refs.terminatedptwfile.files[0];

        // this.selectedFileNamePTW = this.$refs.ptwfile.files[0].name;
        // this.allfileTPTWname.push(this.selectedFileNamePTW);

        const formData = new FormData();
        formData.append("document", this.docsPTW);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.$http
          .post(
            ":10001/api/v1/incoming/" + this.jobno + "/terminated-ptw",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              console.log("ni output", response);
              this.message = response;
              // this.modals.successModal = true;

              this.uploadloadTPTW = false;

              swal({
                title: `Success!`,
                text: "File successfully uploaded.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              });
              setTimeout(() => {
                this.getDetail();
              }, 1000);
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });

        this.uploadloadTPTW = false;
      }
    },
    removePTWFile() {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/incoming/" + this.jobno + "/terminated-ptw")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.allfileTPTWname = [];

                swal({
                  title: `Success!`,
                  text: "File successfully deleted.",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
              }
            });
        }
      });
    },
    opendropjob() {
      this.successModalFlag = "cancel";
      this.modals.dropjob = true;
    },
    redirect(flag) {
      if (flag == "userlists") {
        this.$router.push("/Incoming");
      }
    },
    cancelremarks() {
      let obj = {
        remarks: this.cancellationremarks,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/cancel", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.modals.dropjob = false;
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    viewImage(file) {
      console.log(file);
      this.imagess = file.fileurl;
      this.modals.viewImage = true;
    },
    async generated() {
      try {
        console.log("masuk tak ek");
        await this.$http
          .post(":10001/api/v1/incoming/" + this.jobno + "/generate-wdr")
          .then((res) => {
            if (!res.error) {
              console.log(res);
              console.log("tak errorr");
              this.generate = true;
            } else {
              console.log("errorr");
              // this.modals.warningsubmit = false;

              swal({
                title: "Operation incomplete!",
                text: `Waiting for operation to complete.`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
              this.generate = false;
            }
            console.log("pastu");
          });
      } catch (error) {
        console.error("Request failed", error);

        // Handle unexpected errors
        swal({
          title: "Operation incomplete!",
          text: "Waiting for operation to complete.",
          type: "warning",
          confirmButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
        this.generate = false;
      }
      console.log("masuk kot");
    },
    async viewGeneratedQuo() {
      this.wdr.wastedetails = [];
      await this.$http
        .get(":10001/api/v1/incoming/" + this.jobno + "/do/generate")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("generate quo");
            console.log(response);

            this.wdr.wdrno = this.jobno;
            this.wdr.locationname = response.location;
            this.wdr.receptionfacility =
              response.reception_facility_provider == ""
                ? "N/A"
                : response.reception_facility_provider;
            this.wdr.treatmentfacility =
              response.treatment_facility_provider == ""
                ? "N/A"
                : response.treatment_facility_provider;
            // this.wdr.date = response.waste_discharge_date;
            this.wdr.date = moment(response.ptw_issued_at).format("YYYY-MM-DD");
            this.wdr.dates = moment(response.wdr_issued_at).format(
              "DD.MM.YYYY"
            );

            this.wdr.starttime = moment(response.ptw_issued_at).format(
              "hh:mm:ss a"
            );
            this.wdr.endtime = moment(response.wdr_issued_at).format(
              "hh:mm:ss a"
            );
            this.wdr.shipname = response.ship.ship_name;
            this.wdr.owner = response.ship.operator_name;
            this.wdr.imonumber = response.ship.imo_number;
            this.wdr.distinctive = response.ship.distinctive_number;

            this.wdr.grosstonnage = response.ship.gross_tonnage;
            this.wdr.flagstate = response.ship.flag_country_name;

            for (var i = 0; i < response.waste_detail.length; i++) {
              let subarray = [];
              for (
                var j = 0;
                j < response.waste_detail[i].waste_sub_type.length;
                j++
              ) {
                let type = {
                  name: response.waste_detail[i].waste_sub_type[j]
                    .sub_type_name,
                  amount:
                    response.waste_detail[i].waste_sub_type[j]
                      .estimated_quantity,
                };
                subarray.push(type);
              }
              // hmm
              let obj = {
                wastetype: response.waste_detail[i].waste_type_name,
                wastesub: subarray,
              };

              this.wdr.wastedetails.push(obj);
            }
          }
        });
    },
    async dunlud() {
      this.styledef = "display: block";
      var doc = jsPDF("p", "mm", "a4");
      var width = doc.internal.pageSize.getWidth() + 15;
      var height = doc.internal.pageSize.getHeight();
      console.log(screen.width, screen.height);
      await setTimeout(async () => {
        const canvas = document.getElementById("quopdf");
        const canvaselement = await html2canvas(canvas, {
          useCORS: true,
          allowTaint: true,
          width: (screen.width / 12) * 8,
          height: 1300,
        });

        doc.addImage(canvaselement, "png", 5, 5, width, height);

        doc.save("WDO.pdf");
        this.styledef = "display: none";
      }, 1000);
    },
    createWDO() {
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      // Example data to include in the PDF
      const data = this.wastedetails;

      const customRow = "\t\t\t\t\t\t\tWASTE PARTICULARS";

      // Define the columns for the table
      const columns = [
        "No.",
        "\t\t\t\tWaste Code or Waste Description",
        "Packaging",
        "Quantity (MT)",
      ];
      // Define the rows for the table
      const rows = data.map((obj) => [obj.no, obj.waste, obj.pack, obj.est]);

      // Add logo image on top right
      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      ); // Adjust position and dimensions as needed

      // Add title "Quotation" on top left
      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("WASTE DELIVERY ORDER", 15, 40);
      doc.setFontSize(11);
      doc.setFontStyle("normal");
      // doc.text("DHES SST ID No :", 130, 40);
      doc.setFontStyle("bold");

      doc.text("CUSTOMER DETAIL", 20, 55);

      doc.text(this.picFullName, 20, 60);
      doc.setFontStyle("normal");
      doc.text(this.companyName, 20, 65);
      var companyAddress = this.companyAddress;
      var maxCharactersPerLine = 40;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 70 + i * 5;
        doc.text(addressLines[i], 20, yPos);
      }

      var boxheight = addressLines.length * 14.5;
      doc.setDrawColor(0, 0, 0);

      doc.rect(15, 50, 80, boxheight);

      var squareX = 110;
      var squareY = 50;
      var squareWidth = 85;
      // var squareHeight = 26; // Adjusted height
      var squareHeight = 20; // Adjusted height

      doc.setDrawColor(0, 0, 0);

      // Draw a square
      doc.rect(squareX, squareY, squareWidth, squareHeight);

      // // Set up text
      var textX = squareX + 5; // Adjust this value as needed for text position
      var textY = squareY + 7; // Adjust this value as needed for text position
      var lineHeight = 7; // Adjust this value as needed for line spacing

      // // Add text inside the square
      doc.text("Delivery Order No.", textX, textY);
      doc.text("Date", textX, textY + lineHeight);
      // doc.text("WCO No", textX, textY + lineHeight + lineHeight);

      // // Add colons
      doc.text(" : ", textX + 35, textY);
      doc.text(" : ", textX + 35, textY + lineHeight);
      // doc.text(" : ", textX + 35, textY + lineHeight + lineHeight);

      // // Add dynamic data
      doc.text(this.jobno, textX + 38, textY);
      doc.text(this.wdr.dates, textX + 38, textY + lineHeight);
      // doc.text('linked reference no', textX + 38, textY + lineHeight + lineHeight);

      const columnss = ["\t\t\t\t\t\t\t\t\tJOB PARTICULAR"];

      const datass = [
        {
          a:
            "\nDate\t: \t" +
            this.collectiondate +
            " \nWaste Collection Location\t: \t" +
            this.servicelocationcollection +
            " \nVehicle Registration Number\t: \t- \nName of Driver\t: \t- \n ",
        },
      ];

      const rowss = datass.map((obj) => [obj.a]);

      doc.setFontSize(11);

      // doc.setDrawColor(200, 200, 200);
      // doc.rect(14, 89, 181.5, 10);
      // doc.setFontStyle("bold");

      // doc.text("\tJOB PARTICULAR", 80, 95);

      const tablefirst = doc.autoTable({
        head: [columnss],
        body: rowss,
        startY: 60 + boxheight,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: 182 },
        },

        didDrawCell: function (data) {
          doc.setDrawColor(0, 0, 0);
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        // styles: {
        //   fontSize: 7,
        // },
      });

      doc.setDrawColor(0, 0, 0);
      doc.rect(14.14, 129.8, 181.7, 10);
      doc.setFontStyle("bold");

      doc.text(
        "WASTE PARTICULAR",
        80,
        12 + tablefirst.autoTable.previous.finalY
      );

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 9,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 21,
          },
          3: {
            halign: "center",
            cellWidth: 27,
          },
        },
        theme: "plain",
        body: rows,
        startY: 15.4 + tablefirst.autoTable.previous.finalY,
        didDrawCell: function (data) {
          doc.setDrawColor(0, 0, 0);
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },
      });

      let tableHeight = table.autoTable.previous.finalY;

      if (tableHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        tableHeight = 20;
      }

      // const tableHeight = table.autoTable.previous.finalY - 50;
      doc.setFontStyle("bold");

      doc.text(this.companyName, 15, tableHeight + 12);
      doc.setFontStyle("normal");

      // doc.text(this.locationname, 15, tableHeight + 67);
      doc.text(
        "I/We hereby accept the above services in a good order and condition:-",
        15,
        tableHeight + 27
      );
      doc.text("Name", 15, tableHeight + 37);
      doc.text(": ___________________________________", 55, tableHeight + 37);

      doc.text("Signature", 15, tableHeight + 47);
      doc.text(": ___________________________________", 55, tableHeight + 47);

      doc.text("Company Stamp", 15, tableHeight + 57);
      doc.text(": ", 55, tableHeight + 57);
      doc.setFontStyle("bold");

      doc.text(
        "Alam Flora Environmental Solutions Sdn. Bhd. (AFES)",
        55,
        tableHeight + 82
      );
      // doc.setFontSize(8);
      doc.setFontStyle("italic");
      doc.setFontStyle("normal");

      doc.text(
        "(previously known as DRB-HICOM Environmental Services Sdn Bhd)",
        45,
        tableHeight + 87
      );
      doc.setFontSize(11);
      doc.text(
        "Level 2, EON Head Office Complex, 2, Persiaran Kerjaya U1",
        55,
        tableHeight + 97
      );
      doc.text(
        "40150 Shah Alam, Selangor Darul Ehsan, MALAYSIA",
        60,
        tableHeight + 102
      );
      doc.text(
        "Tel: (603) 7803 0518 Fax: (603) 7809 0137 Web: www.afes.com.my",
        45,
        tableHeight + 107
      );

      doc.save("Waste Delivery Order.pdf");
    },
    async createPDFnew() {
      var doc = new jsPDF();
      const data = [
        {
          num1: "2.1",
          desc1: "Name of ship: " + this.wdr.shipname,
          num2: "2.5",
          desc2: "Owner or operator: " + this.wdr.owner,
        },
        {
          num1: "2.2",
          desc1: "IMO number: " + this.wdr.imonumber,
          num2: "2.6",
          desc2: "Distinctive number of letters: " + this.wdr.distinctive,
        },
        {
          num1: "2.3",
          desc1: "Gross Tonnage: " + this.wdr.grosstonnage,
          num2: "2.7",
          desc2: "Flag State: " + this.wdr.flagstate,
        },
      ];
      const rows = data.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.num2,
        obj.desc2,
      ]);

      const datas = [
        {
          num1: "2.4",
          desc1:
            "Type of ship:  \tOil tanker (\t" +
            this.oiltanker +
            "\t) \tChemical tanker (\t" +
            this.chemicaltanker +
            "\t) \tBulk carrier (\t" +
            this.bulkcarrier +
            ") \tContainer (\t" +
            this.container +
            "\t) \n\n \t\t\tOther cargo chip (\t" +
            this.othercargoship +
            "\t) \tPassenger ship (\t" +
            this.passenger +
            "\t) \tRo-ro (\t" +
            this.roro +
            "\t) \tOther (specify) (\t" +
            this.other +
            "\t)",
          // num2: "Oil Tanker",
          // desc2: this.oiltanker,
          // num3: "Chemical Tanker",
          // desc3: this.chemicaltanker,
          // num4: "Bulk Carrier",
          // desc4: this.bulkcarrier,
          // num5: "Container",
          // desc5: this.container,
        },
        // {
        // num1: "",
        // desc1: "",
        // num2: "Other cargo ship",
        // desc2: this.othercargoship,
        // num3: "Passenger ship",
        // desc3: this.passenger,
        // num4: "Ro-ro",
        // desc4: this.roro,
        // num5: "Other (specify)",
        // desc5: this.other,
        // },
      ];
      const rowss = datas.map((obj) => [
        obj.num1,
        obj.desc1,
        // obj.num2,
        // obj.desc2,
        // obj.num3,
        // obj.desc3,
        // obj.num4,
        // obj.desc4,
        // obj.num5,
        // obj.desc5,
      ]);

      const data2 = [
        {
          num1: "1.1",
          desc1: "Location/Terminal name: " + this.wdr.locationname,
        },
        {
          num1: "1.2",
          desc1:
            "Reception facility provider(s): " + this.wdr.receptionfacility,
        },
        {
          num1: "1.3",
          desc1:
            "Treatment facility provider(s) - if different from above: " +
            this.wdr.treatmentfacility,
        },
        {
          num1: "1.4",
          desc1:
            "Waste Discharge Date: " +
            this.wdr.date +
            " from " +
            this.wdr.starttime +
            " to " +
            this.wdr.endtime,

          // "Waste Discharge: " +
          // this.wdr.date +
          // " from: " +
          // this.wdr.starttime +
          // " to " +
          // this.wdr.endtime,
        },
      ];
      const rows2 = data2.map((obj) => [obj.num1, obj.desc1]);

      const data3 = [
        {
          num1: "MARPOL Annex I - Oil",
          desc1: "Quantity (M³)",
          desc12: "Quantity (MT)",
          num2: "MARPOL Annex V - Garbage",
          desc2: "Quantity (M³)",
          desc22: "Quantity (MT)",
        },
        {
          num1: "Oily bilge water",
          desc1: this.aa,
          desc12: this.aaa,
          num2: "A. Plastics",
          desc2: this.a,
          desc22: this.aremark,
        },
        {
          num1: "Oil residues (sludge)",
          desc1: this.bb,
          desc12: this.bbb,
          num2: "B. Food wastes",
          desc2: this.b,
          desc22: this.bremark, //remarks
        },
        {
          num1: "Oily tank washings",
          desc1: this.cc,
          desc12: this.ccc,
          num2: "C. Domestic wastes (e.g. paper products, rags, glass, metal, bottles, crockery, etc.)",
          desc2: this.c,
          desc22: this.cremark, //remarks
        },
        {
          num1: "Dirty ballast water",
          desc1: this.dd,
          desc12: this.ddd,
          num2: "D. Cooking oil",
          desc2: this.d,
          desc22: this.dremark, //remarks
        },
        {
          num1: "Scale and sludge from tank cleaning",
          desc1: this.ee,
          desc12: this.eee,
          num2: "E. Incinerator ashes",
          desc2: this.e,
          desc22: this.eremark, //remarks
        },
        {
          num1: "Other (please specify)",
          desc1: this.ff,
          desc12: this.fff,
          num2: "F. Operational wastes",
          desc2: this.f,
          desc22: this.fremark, //remarks
        },
        {
          num1: "MARPOL Annex II - NLS",
          desc1: "",
          num2: "G. Cargo residues²",
          desc2: this.g,
          desc22: this.gremark,
        },
        {
          num1: "Category X substance",
          desc1: this.xpdf,
          desc12: this.xxpdf,
          num2: "H. Animal carcass(es)",
          desc2: this.h,
          desc22: this.hremark,
        },
        {
          num1: "Category Y substance",
          desc1: this.ypdf,
          desc12: this.yypdf,
          num2: "I. Others: " + this.otherspecify,
          desc2: this.i,
          desc22: this.iremark,
        },
        {
          num1: "Category Z substance",
          desc1: this.zpdf,
          desc12: this.zzpdf,
          num2: "MARPOL Annex VI - related",
          desc2: this.sewage,
          desc22: this.sewageremark,
        },
        {
          num1: "OS - other substance",
          desc1: this.ospdf,
          desc12: this.osspdf,
          num2: "Ozone-depleting substances and equipment containing such substances",
          desc2: this.ozone,
          desc22: this.ozoneremark,
        },
        {
          num1: "MARPOL Annex IV - Sewage",
          desc1: "",
          num2: "Exhaust gas-cleaning residues",
          desc2: this.exhaust,
          desc22: this.exhaustremark,
        },
        {
          num1: "",
          desc1: "",
          num2: "",
          desc2: "",
        },
      ];
      const rows3 = data3.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.desc12,
        obj.num2,
        obj.desc2,
        obj.desc22,
      ]);

      const logo = new Image();
      logo.src = require("@/assets/img/afesneww.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      // var logoimage = "https://m.media-amazon.com/images/I/71T2m0TSIYL._AC_UF894,1000_QL80_.jpg";
      var logoimageurl = ""; //for responsive logo

      const logo1 = new Image();

      if (logoimageurl != "") {
        logo1.src = logoimageurl;
        logo1.onload = () => {
          this.options = Object.assign({}, this.options, {
            logo1: {
              logo1,
            },
          });
        };
      } else if (logoimageurl == "") {
        logo1.src = require("@/assets/img/blank.png");
        logo1.onload = () => {
          this.options = Object.assign({}, this.options, {
            logo1: {
              logo1,
            },
          });
        };
      }

      doc.setFontSize(9);
      doc.text("WDR NO: " + this.jobno + "", 150, 5);
      doc.setFontSize(10);

      doc.setFontStyle("bold");
      doc.text("WASTE DELIVERY RECEIPT", 80, 45);
      doc.setFontSize(8);

      doc.addImage(
        logo1,
        "PNG",
        doc.internal.pageSize.getWidth() - 200,
        5,
        65,
        30
      );

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setLineWidth(0.3); // Set line width
      doc.line(10, 35, doc.internal.pageSize.getWidth() - 10, 35);

      doc.setFontStyle("italic");
      doc.text(
        "This form should be retained on board the vessel along with the appropriate Oil RB, Cargo RB or Garbage RB.",
        10,
        50
      );
      doc.setFontStyle("normal");

      let startY1 = 55;

      doc.setFontSize(9);
      doc.setFontStyle("bold");

      doc.text("1.", 15, startY1);
      doc.text("RECEPTION FACILITY AND PORT PARTICULARS", 25, startY1);

      doc.setFontSize(7);
      doc.setFontStyle("normal");
      const columnWidths = [8, 85, 8, 85];
      const column = [8, 178];

      const lastRowColumnWidths = [10, 26, 26, 10, 26, 10, 26, 10, 26, 10];
      doc.autoTable({
        body: rows2,
        startY: startY1 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: column[0] },
          1: { columnWidth: column[1] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      const columnWidthss = [8, 30, 29, 8, 29, 8, 29, 8, 29, 8];

      let startY2 = doc.autoTable.previous.finalY + 8;

      doc.setFontSize(9);
      doc.setFontStyle("bold");
      doc.text("2.", 15, startY2);
      doc.text("SHIP PARTICULARS", 25, startY2);

      doc.setFontSize(7);
      doc.setFontStyle("normal");
      doc.autoTable({
        body: rows,
        startY: startY2 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidths[0] },
          1: { columnWidth: columnWidths[1] },
          2: { columnWidth: columnWidths[2] },
          3: { columnWidth: columnWidths[3] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      // const columnWidthss = [8, 30, 29, 8, 29, 8, 29, 8, 29, 8];

      doc.autoTable({
        body: rowss,
        startY: doc.autoTable.previous.finalY,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidthss[0] },
          1: { columnWidth: 178 },
          // 2: { columnWidth: columnWidthss[2] },
          // 3: { columnWidth: columnWidthss[3] },
          // 4: { columnWidth: columnWidthss[4] },
          // 5: { columnWidth: columnWidthss[5] },
          // 6: { columnWidth: columnWidthss[6] },
          // 7: { columnWidth: columnWidthss[7] },
          // 8: { columnWidth: columnWidthss[8] },
          // 9: { columnWidth: columnWidthss[9] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      // doc.addPage();
      let startY3 = doc.autoTable.previous.finalY + 8;
      // let startY3 = 120;

      console.log(startY3);
      let startY4 = startY2 + doc.autoTable.previous.finalY + 8;

      doc.setFontSize(9);
      doc.setFontStyle("bold");
      doc.text("3.", 15, startY3);
      doc.text(
        "TYPE AND AMOUNT OF WASTES/RESIDUES FOR DISCHARGE TO FACILITY",
        25,
        startY3
      );

      const columnWidth = [42, 23, 23, 52, 23, 23];
      doc.autoTable({
        body: rows3,
        startY: startY3 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidth[0], halign: "left" },
          1: { columnWidth: columnWidth[1], halign: "center" },
          2: { columnWidth: columnWidth[2], halign: "center" },
          3: { columnWidth: columnWidth[3], halign: "left" },
          4: { columnWidth: columnWidth[4], halign: "center" },
          5: { columnWidth: columnWidth[5], halign: "center" },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      doc.setFontSize(8);
      doc.setFontStyle("normal");

      let startY7 = startY3 + 100;
      doc.text(
        "On behalf of the port facility I confirm that the above wastes were delivered.",
        25,
        startY7 + 5
      );
      doc.text("Signature", 25, startY7 + 10);
      doc.text(":", 55, startY7 + 10);
      doc.text("Full Name and Company", 85, startY7 + 10);
      doc.text(":", 125, startY7 + 10);
      doc.text("Stamp", 85, startY7 + 15);

      doc.text("Client' signature", 25, startY7 + 25);
      doc.text(":", 55, startY7 + 25);
      doc.text("Full Name and Company", 85, startY7 + 25);
      doc.text(":", 125, startY7 + 25);
      doc.text("Stamp", 85, startY7 + 30);

      doc.text(
        "1  Indicate the proper shipping name of the NLS involved.",
        25,
        startY7 + 35
      );
      doc.text(
        "2  Indicate the proper shipping name of dry cargo.",
        25,
        startY7 + 38
      );
      doc.setLineWidth(0.3); // Set line width
      doc.line(
        10,
        startY7 + 39,
        doc.internal.pageSize.getWidth() - 10,
        startY7 + 39
      );

      doc.text("Remarks:", 25, startY7 + 45);
      doc.text(
        "1. Charges are based on the weight measured on the weighbridge.",
        25,
        startY7 + 48
      );
      doc.text(
        "2. WDR will be attach together with weighbridge chit for the claim purposes.",
        25,
        startY7 + 51
      );

      doc.save("Waste Delivery Receipt.pdf");

      console.log("pdf created");
    },
    saveDraft() {
      let obj = {
        lab_report: this.checkedItems == "" ? false : this.checkedItems,
        inspection_picture:
          this.checkedItems1 == "" ? false : this.checkedItems1,
        // inspection_picture_id: [],
        // removed_inspection_picture_id: [], // inspection picture to remove
        // lab_report_id: [],
        // removed_lab_report_id: [], // lab report to remove
      };
      this.$http
        .put(":10001/api/v1/incoming/" + this.jobno + "/do/save", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            swal({
              title: `Success!`,
              text: response,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              if (result.value) {
                this.generate = true;
              }
            });
          }
        });
    },
    onReceiptChange() {
      this.uploadreceipt = true;
      // only 1 pdf can be uploaded (do checking)
      // if (this.allreceiptPTW.length < 1) {
      // swal({
      //   title: "Are you sure?",
      //   text: `You won't be able to revert this!`,
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonClass: "btn btn-primary btn-fill",
      //   cancelButtonClass: "btn btn-cancel btn-fill",
      //   confirmButtonText: "Continue",
      //   buttonsStyling: false,
      // }).then((result) => {
      // if (result.value == true) {
      let data = this.$refs.receiptupload.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/do/waste-disposal-receipt",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;

            this.uploadreceipt = false;
            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            this.getDetail();
          }
        });
      //   }
      // });
      // } else {
      //   swal({
      //     title: `Info!`,
      //     text: "Only 1 file allowed to be uploaded",
      //     buttonsStyling: false,
      //     confirmButtonClass: "btn btn-primary btn-fill",
      //     type: "info",
      //   });
      //   this.uploadreceipt = false;
      // }
    },
    generateWDR() {
      let obj = {
        lab_report: this.checkedItems == "" ? false : this.checkedItems,
        inspection_picture:
          this.checkedItems1 == "" ? false : this.checkedItems1,
        // inspection_picture_id: [],
        // removed_inspection_picture_id: [], // inspection picture to remove
        // lab_report_id: [],
        // removed_lab_report_id: [], // lab report to remove
      };
      this.$http
        .put(":10001/api/v1/incoming/" + this.jobno + "/do/submit", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            // this.modals.successModal = true

            // this.generate = true;

            this.generated();
            this.viewGeneratedQuo();
          }
        });
    },
    generateInvoice() {
      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/invoice/generate-email"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("dapat apa?", response);
          }
        });
    },
    getDetail() {
      this.wastedetails = [];
      this.allfilename = [];
      this.allimagename = [];
      this.allreceiptPTW = [];
      this.timesheets = [];
      this.allfileTPTWname = [];
      this.shipdoc = [];

      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("woi", response);

          if (this.jobno.startsWith("L")) {
            this.wastecomponent = [];

            for (var i = 0; i < response.waste_detail.length; i++) {
              let combinedName = "";
              for (
                var j = 0;
                j < response.waste_detail[i].waste_component.length;
                j++
              ) {
                if (j > 0) {
                  combinedName += ", "; // Add a separator between component names
                }
                combinedName += String(
                  response.waste_detail[i].waste_component[j]
                    .waste_component_name
                );
              }
              let obj = {
                name: combinedName,
              };
              this.wastecomponent.push(obj);
            }
          }

          this.landvesselflag = response.company.company_type.toUpperCase();

          this.arrivalETA = moment(response.arrival_eta).format("DD MMM YYYY");
          this.collectiondate = moment(response.collection_date).format(
            "DD.MM.YYYY"
          );
          this.servicelocation = response.service_location_name;
          this.servicelocationcollection =
            response.service_location_collection_name;
          this.departureETD = moment(response.departure_eta).format(
            "DD MMM YYYY"
          );
          this.previousPort =
            response.previous_port == "" ? "None" : response.previous_port;
          this.nextPort =
            response.next_port == "" ? "None" : response.next_port;
          this.lastPortAndDate =
            response.last_port == "" ? "None" : response.last_port;

          this.lastDate =
            response.last_port_date == ""
              ? "N/A"
              : moment(response.last_port_date).format("DD MMM YYYY");

          this.companyName = response.company.company_name;
          this.companyAddress = response.company.company_address;
          this.phoneNoFaxNo =
            (response.company.company_phone_number == "" ||
            response.company.company_phone_number == null
              ? "N/A"
              : response.company.company_phone_number) +
            " / " +
            (response.company.company_fax_number == "" ||
            response.company.company_fax_number == null
              ? "N/A"
              : response.company.company_fax_number);
          this.picFullName = response.pic.user_name;
          this.picPhoneNoFaxNo =
            (response.pic.pic_phone_number == "" ||
            response.pic.pic_phone_number == null
              ? "N/A"
              : response.pic.pic_phone_number) +
            " / " +
            (response.pic.pic_fax_number == "" ||
            response.pic.pic_fax_number == null
              ? "N/A"
              : response.pic.pic_fax_number);
          this.picEmail = response.pic.user_email;
          this.shipName = response.ship.ship_name;
          this.imoNo = response.ship.imo_number;
          this.shipType = response.ship.ship_type_name;
          this.grossTonnage = response.ship.gross_tonnage;
          this.deadweightTonnage = response.ship.deadweight_tonnage;
          this.owneroperatorname = response.ship.operator_name;
          this.callSign = response.ship.call_sign;
          this.flagState = response.ship.country_name;
          // this.sustainableCertificates =
            // response.ship.documents == null ? "None" : response.ship.documents;

            if (response.ship.documents != null) {
            for (var i = 0; i < response.ship.documents.length; i++) {
              let obj = {
                filename: response.ship.documents[i].meta.filename,
                fileid: response.ship.documents[i].ship_document_id,
                fileurl: response.ship.documents[i].url,
              };
              this.shipdoc.push(obj);
            }
          }
          
          if (this.shipType === "Oil Tanker") {
            this.oiltanker = "/";
          } else if (this.shipType === "Chemical Tanker") {
            this.chemicaltanker = "/";
          } else if (this.shipType === "Bulk Carrier") {
            this.bulkcarrier = "/";
          } else if (this.shipType === "Container") {
            this.container = "/";
          } else if (this.shipType === "Other Cargo Ship") {
            this.othercargoship = "/";
          } else if (this.shipType === "Passenger Ship") {
            this.passenger = "/";
          } else if (this.shipType === "Ro-ro") {
            this.roro = "/";
          } else {
            this.other = "/";
          }

          // this.subjectline = response.quotation.subject_line;
          // this.deliveryterm = response.quotation.delivery_term;
          // this.paymentterm = response.quotation.payment_term;
          // this.validity = response.quotation.validity;
          // this.remark1 = response.quotation.remarks;

          // waste detail
          for (var i = 0; i < response.waste_detail.length; i++) {
            let amount =
              response.waste_detail[i].rate *
              response.waste_detail[i].estimated_quantity;

            let obj = {};

            if (this.jobno.startsWith("V")) {
              if (
                response.waste_detail[i].waste_type_name === "Annex I - Oil"
              ) {
                const subTypeName =
                  response.waste_detail[i].waste_type_sub_name;

                if (subTypeName === "Oily bilge water") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.aaa = response.waste_detail[i].calculated_quantity;
                  // else
                  this.aa = response.waste_detail[i].estimated_quantity;
                }

                if (subTypeName === "Oily residues (sludge)") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.bbb = response.waste_detail[i].calculated_quantity;
                  // else
                  this.bb = response.waste_detail[i].estimated_quantity;
                }

                if (subTypeName === "Oily tank washings") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.ccc = response.waste_detail[i].calculated_quantity;
                  // else
                  this.cc = response.waste_detail[i].estimated_quantity;
                }

                if (subTypeName === "Dirty ballast water") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.ddd = response.waste_detail[i].calculated_quantity;
                  // else
                  this.dd = response.waste_detail[i].estimated_quantity;
                }

                if (subTypeName === "Scale and sludge from tank cleaning") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.eee = response.waste_detail[i].calculated_quantity;
                  // else
                  this.ee = response.waste_detail[i].estimated_quantity;
                }

                if (subTypeName.includes("specify")) {
                  //betul ke ni ?
                  // this.ffspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.fff = response.waste_detail[i].calculated_quantity;
                  // else
                  this.ff = response.waste_detail[i].estimated_quantity;
                }
              }

              //belum okay
              if (
                response.waste_detail[i].waste_type_name == "Annex II - NLS"
              ) {
                // const subTypeMap = {
                //   "Category X substance (specify)": "xpdf",
                //   "Category Y substance (specify)": "ypdf",
                //   "Category Z substance (specify)": "zpdf",
                //   "Other substances (specify)": "ospdf",
                // };

                // for (
                //   let j = 0;
                //   j < response.waste_detail[i].waste_sub_type.length;
                //   j++
                // ) {
                const subTypeName =
                  response.waste_detail[i].waste_type_sub_name;
                // const quantity =
                //   response.waste_detail[i].waste_sub_type
                //     .estimated_quantity;

                // if (subTypeMap.hasOwnProperty(subTypeName)) {
                //   this[subTypeMap[subTypeName]] = quantity;
                // }

                if (subTypeName === "Category X substance") {
                  // this.xspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  // if (
                  //   response.waste_detail[i].waste_sub_type
                  //     .estimated_quantity_unit == "M³"
                  // ) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.xxpdf = response.waste_detail[i].calculated_quantity;
                  // } else if (
                  //   response.waste_detail[i].waste_sub_type
                  //     .estimated_quantity_unit == "MT"
                  // ) {
                  // else
                  this.xpdf = response.waste_detail[i].estimated_quantity;
                  // }
                }

                if (subTypeName.includes("Category Y substance")) {
                  // this.yspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  // if (
                  //   response.waste_detail[i].waste_sub_type
                  //     .estimated_quantity_unit == "M³"
                  // ) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.yypdf = response.waste_detail[i].calculated_quantity;
                  // } else if (
                  //   response.waste_detail[i].waste_sub_type
                  //     .estimated_quantity_unit == "MT"
                  // ) {
                  // else
                  this.ypdf = response.waste_detail[i].estimated_quantity;
                  // }
                }

                if (subTypeName.includes("Category Z substance")) {
                  // this.zspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  // if (
                  //   response.waste_detail[i].waste_sub_type
                  //     .estimated_quantity_unit == "M³"
                  // ) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.zzpdf = response.waste_detail[i].calculated_quantity;
                  // else
                  this.zpdf = response.waste_detail[i].estimated_quantity;
                  // }
                }

                if (subTypeName.includes("Other substance")) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.osspdf = response.waste_detail[i].calculated_quantity;
                  // else
                  this.ospdf = response.waste_detail[i].estimated_quantity;
                }
              }

              if (
                response.waste_detail[i].waste_type_name == "Annex IV - Sewage"
              ) {
                if (
                  response.waste_detail[i].waste_type_sub_name ==
                  "Untreated/Partially treated"
                ) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.sewageremark =
                    response.waste_detail[i].calculated_quantity;
                  // else
                  this.sewage = response.waste_detail[i].estimated_quantity;

                  // this.sewageremark =
                  //   response.waste_detail[i].waste_sub_type.remark;

                  // this.sewagestorage =
                  //   response.waste_detail[
                  //     i
                  //   ].waste_sub_type.dedicated_storage_capacity;

                  // this.sewageretain =
                  //   response.waste_detail[
                  //     i
                  //   ].waste_sub_type.waste_retained_onboard;
                }
              }

              if (
                response.waste_detail[i].waste_type_name === "Annex V - Garbage"
              ) {
                const subTypeName =
                  response.waste_detail[i].waste_type_sub_name;

                if (subTypeName === "Plastics") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.aremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.a = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName === "Food wastes") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.bremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.b = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName.includes("Domestic waste")) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.cremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.c = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName === "Cooking oil") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.dremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.d = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName === "Incinerator ashes") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.eremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.e = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName === "Operational wastes") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.fremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.f = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName === "Cargo residues²") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.gremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.g = response.waste_detail[i].estimated_quantity;
                } else if (subTypeName === "Animal carcass(es)") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.hremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.h = response.waste_detail[i].estimated_quantity;
                } else {
                  //betul ke sini?
                  // this.otherspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.iremark = response.waste_detail[i].calculated_quantity;
                  // else
                  this.i = response.waste_detail[i].estimated_quantity;
                }
              }

              if (
                response.waste_detail[i].waste_type_name ===
                "Annex VI - Air Pollution"
              ) {
                const subTypeName =
                  response.waste_detail[i].waste_type_sub_name;

                if (
                  subTypeName ===
                  "Ozone depleting substances and equipment containing such substances"
                ) {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.ozoneremark =
                    response.waste_detail[i].calculated_quantity;
                  // else
                  this.ozone = response.waste_detail[i].estimated_quantity;
                }

                if (subTypeName === "Exhaust cleaning residues") {
                  // if (response.waste_detail[i].estimated_quantity_unit == "MT")
                  this.exhaustremark =
                    response.waste_detail[i].calculated_quantity;
                  // else
                  this.exhaust = response.waste_detail[i].estimated_quantity;
                }
              }

              obj = {
                id: response.waste_detail[i].waste_detail_id,
                description: response.waste_detail[i].waste_type_name,
                rate: parseInt(response.waste_detail[i].rate),
                estamount: response.waste_detail[i].estimated_quantity,
                amount: amount,
                wastetype: response.waste_detail[i].waste_type_name,
                wastesubtype: response.waste_detail[i].waste_type_sub_name,
                wasteqty:
                  response.waste_detail[i].estimated_quantity +
                  " " +
                  response.waste_detail[i].estimated_quantity_unit,
                actual: response.waste_detail[i].calculated_quantity +  " " +
                response.waste_detail[i].estimated_quantity_unit,
                maxdedicatedstoragecapacity:
                  response.waste_detail[i].dedicated_storage_capacity +
                  " " +
                  response.waste_detail[i].dedicated_storage_capacity_unit,
                wasteamountretainedonboard:
                  response.waste_detail[i].waste_retained_onboard +
                  " " +
                  response.waste_detail[i].waste_retained_onboard_unit,
                remarks: response.waste_detail[i].remarks,
              };
              this.wastedetails.push(obj);
            } else

            if (this.jobno.startsWith("L")) {
              obj = {
                no: i + 1,
                waste:
                  // response.waste_detail[i].waste_type_name +
                  // "\n" +
                  // "Waste Sub Type: " +
                  response.waste_detail[i].waste_type_sub_name,
                // +
                // "\n" +
                // "Origin: " +
                // response.waste_detail[i].waste_source +
                // "\n" +
                // "Waste Component: " +
                // this.wastecomponent[i].name +
                // "\n" +
                // "Remark: " +
                // response.waste_detail[i].remarks, // tambah sub type
                est: response.waste_detail[i].estimated_quantity.toString(),
                // +
                // " " +
                // response.waste_detail[i].estimated_quantity_unit,
                pack:
                  response.waste_detail[i].packaging_quantity.toString() +
                  " " +
                  response.waste_detail[i].packaging_type_name,

                id: response.waste_detail[i].waste_detail_id,
                description: response.waste_detail[i].waste_type_name,
                rate: parseInt(response.waste_detail[i].rate),
                estamount: response.waste_detail[i].estimated_quantity,
                amount: amount,
                wastetype: response.waste_detail[i].waste_type_name,
                wastesubtype: response.waste_detail[i].waste_type_sub_name,
                wasteqty:
                  response.waste_detail[i].estimated_quantity +
                  " " +
                  response.waste_detail[i].estimated_quantity_unit,
                actual: response.waste_detail[i].calculated_quantity + " MT",
                maxdedicatedstoragecapacity:
                  response.waste_detail[i].dedicated_storage_capacity +
                  " " +
                  response.waste_detail[i].dedicated_storage_capacity_unit,
                wasteamountretainedonboard:
                  response.waste_detail[i].waste_retained_onboard +
                  " " +
                  response.waste_detail[i].waste_retained_onboard_unit,
                remarks: response.waste_detail[i].remarks,
              };
              this.wastedetails.push(obj);
            }
            // this.pdftable.push(obj);
          }

          // lab report
          if (response.lab_report != null) {
            for (var i = 0; i < response.lab_report.length; i++) {
              let obj = {
                fileid: response.lab_report[i].lab_report_id,
                filename: response.lab_report[i].meta.filename,
                fileurl: response.lab_report[i].url,
              };

              this.allfilename.push(obj);
            }
          }

          // inspection image
          if (response.inspection_picture != null) {
            for (var i = 0; i < response.inspection_picture.length; i++) {
              let obj = {
                fileid: response.inspection_picture[i].inspection_picture_id,
                filename: response.inspection_picture[i].meta.filename,
                fileurl: response.inspection_picture[i].url,
              };

              this.allimagename.push(obj);
            }
          }

          // receipt pdf
          if (response.wdr_support_document != null) {
            for (var i = 0; i < response.wdr_support_document.length; i++) {
              let obj = {
                fileid:
                  response.wdr_support_document[i].wdr_support_document_id,
                filename: response.wdr_support_document[i].meta.filename,
                fileurl: response.wdr_support_document[i].url,
                rev: response.wdr_support_document[i].rev,
              };
              this.allreceiptPTW.push(obj);
            }
          }

          //terminatedptw
          if (response.terminated_ptw != null) {
            // for (var i = 0; i < response.terminated_ptw.length; i++) {
            let obj = {
              fileid: response.terminated_ptw.document_id,
              filename: response.terminated_ptw.meta.filename,
              fileurl: response.terminated_ptw.url,
            };
            this.allfileTPTWname.push(obj);
            // }

            console.log("ni ha", this.allfileTPTWname);
          }

          // timesheet
          if (response.incoming_timesheet != null) {
            for (var i = 0; i < response.incoming_timesheet.length; i++) {
              let obj = {
                fileid: response.incoming_timesheet[i].incoming_timesheet_id,
                filename: response.incoming_timesheet[i].meta.filename,
                fileurl: response.incoming_timesheet[i].url,
              };
              this.timesheets.push(obj);
            }
          }
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    nextTab() {
      let parameter = {
        step: "4",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "4",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    onLabChange(event) {
      event.preventDefault();
      this.uploadlabreport = true;

      const fileInput = document.getElementById("lab-upload");
      const selectedFiles = fileInput.files;
      console.log(selectedFiles.length);

      // Check if any files are selected
      const formData = new FormData();
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("document", selectedFiles[i]);
      }

      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/do/lab-report",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.uploadlabreport = false;
            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            this.getDetail();
          }
        });
    },
    removeTimesheet(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/do/upload-timesheet/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                // swal({
                //   title: `Success!`,
                //   text: response,
                //   buttonsStyling: false,
                //   confirmButtonClass: "btn btn-primary btn-fill",
                //   type: "success",
                // });
                this.getDetail();
              }
            });
        }
      });
    },
    removeFile(id) {
      console.log("delete lab report");

      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" + this.jobno + "/do/lab-report/" + id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                // swal({
                //   title: `Success!`,
                //   text: response,
                //   buttonsStyling: false,
                //   confirmButtonClass: "btn btn-primary btn-fill",
                //   type: "success",
                // });
                this.getDetail();
              }
            });
        }
      });
    },
    removeReceipt(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/do/waste-disposal-receipt/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                // swal({
                //   title: `Success!`,
                //   text: response,
                //   buttonsStyling: false,
                //   confirmButtonClass: "btn btn-primary btn-fill",
                //   type: "success",
                // });
                this.getDetail();
              }
            });
        }
      });
    },
    onImagesChange(event) {
      this.uploadimage = true;
      let data = this.$refs.imageupload.files[0];

      const formData = new FormData();
      formData.append("document", data);

      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/do/inspection-picture",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.uploadimage = false;
            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            this.getDetail();
          }
        });
    },
    onTimesheetChange(event) {
      console.log("pgl");
      this.uploadtimesheet = true;
      const t = event.target;

      const formData = new FormData();
      for (let i = 0; i < t.files.length; i++) {
        console.log(this.$refs.timesheetupload);
        let data = this.$refs.timesheetupload.files[i];

        formData.append("document", data);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/do/upload-timesheet",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.uploadtimesheet = false;

            this.getDetail();
          }
        });

      // for (var pair of formData.entries()) {
      //   console.log(pair);
      // }
    },
    removeImage(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/do/inspection-picture/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                // swal({
                //   title: `Success!`,
                //   text: response,
                //   buttonsStyling: false,
                //   confirmButtonClass: "btn btn-primary btn-fill",
                //   type: "success",
                // });
                this.getDetail();
              }
            });
        }
      });
    },

    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },
    onImageChange(file) {
      this.uploadimage = true;
      this.images.regular = file;

      this.img = file.name;
      const reader = new FileReader();

      reader.onload = (event) => {
        file = event.target.result;

        file.replace(event.target.result);
        this.imagebase64 = file.split(",")[1];
        console.log(this.imagebase64);
      };
      reader.readAsDataURL(file);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}

.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB;
  /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.quo {
  font-family: "Poppins";
  font-weight: 600;
  /* font-size: 14px; */
  color: #000000;
  /* line-height: 0.5; */
}

th {
  color: #000000;
  font-family: "Poppins";
  font-weight: 600;
}

td {
  color: #000000;
  font-family: "Poppins";
  font-weight: 600;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.btn-view-image:hover {
  color: #A5A5A5;
  text-decoration: underline;
  cursor: pointer;
}

.el-table .cell {
  word-break: break-word !important;
}
</style>
